import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import geoid21Img from '../assets/images/KSA-GEOID21.png';
import grfTransformationImg from '../assets/images/ksa-grf-transformation-tool.png';
import vrfTransformationImg from '../assets/images/transformation-tool-for-vertical-reference-frame-and-geoid-heights.png';
import arrowGreen from '../assets/icons/arrow-green.svg';



function GeodeticTools() {
  const { t } = useTranslation();
 

 

  return (
    <div style={{ background: 'linear-gradient(135deg, rgba(3, 52, 68, 1) 0%, rgba(3, 52, 68, 0.9) 50%, rgba(3, 52, 68, 1) 100%)' }}>
      <div className="space" style={{ height: '100px' }}></div>

      <h2 className="text-center mb-5" style={{ color: '#fff' }}>
      {t('geodtool_title')}
            </h2>

      <section className="services">
        <div className="service-container-sub">
         

       
            <>
             
             
              {/* ksa-geoid-calculator */}
              <div className="service-card-sub">
              <a href={t('KSA-GEOID_Height_Calculator_url')} target="_blank" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
              <div className="image-container">
                    <img src={geoid21Img} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('ksa-geoid-calculator')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('ksa-geoid-calculator-subtitle')}</p>
                </div>
              </div>
              
              {/* KSA-GRF Transformation Tool */}
              <div className="service-card-sub">
              <a href={t('Online-GRF-TT_url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={grfTransformationImg} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('Online-GRF-TT')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('Online-GRF-TT-subtitle')}</p>
                </div>
              </div>
              {/* KSA-VRF Transformation Tool */}
              <div className="service-card-sub">
              <a href={t('Online-VRF-TT_url')} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div className="image-container">
                    <img src={vrfTransformationImg} alt="Data Catalog" />
                    <div className="icon-overlay">
                      <img src={arrowGreen} alt="Arrow Icon" />
                    </div>
                    <div className="floating-text">
                      <h3>{t('Online-VRF-TT')}</h3>
                    </div>
                  </div>
                </a>
                <div className="text-container">
                  <p>{t('Online-VRF-TT-subtitle')}</p>
                </div>
              </div>
            </>
         

         
        </div>
      </section>

      <div className="space" style={{ height: '100px' }}></div>
    </div>
  );
}

export default GeodeticTools;
